<template>
  <v-popover
    v-if="isClamped"
    boundariesElement=".l-main"
    :handleResize="false"
    :placement="placement"
    :popoverClass="popoverClass"
    trigger="hover"
  >
    <div
      class="c-text--clamp"
      :style="{ '-webkit-line-clamp': clamp }"
      ref="text"
      @mouseenter="setSize"
    >
      <slot></slot>
    </div>
    <template slot="popover">
      <slot name="popover">
        <slot></slot>
      </slot>
    </template>
  </v-popover>
  <div
    v-else
    class="c-text--clamp"
    :style="{ '-webkit-line-clamp': clamp }"
    ref="text"
    @mouseenter="setSize"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    clamp: {
      type: Number,
      required: false,
      default: 1
    },
    placement: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: false
    },
    variant: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      offsetH: 0,
      scrollH: 0
    };
  },
  computed: {
    popoverClass() {
      const cssClass = [];
      if (this.size) {
        cssClass.push('c-popover--' + this.size);
      }
      if (this.variant) {
        cssClass.push('c-popover--' + this.variant);
      }
      return cssClass.join(' ');
    },
    isClamped() {
      return this.offsetH < this.scrollH;
    }
  },
  methods: {
    setSize() {
      if (this.$refs.text) {
        this.offsetH = this.$refs.text.offsetHeight;
        this.scrollH = this.$refs.text.scrollHeight;
      } else {
        this.offsetH = 0;
        this.scrollH = 0;
      }
    }
  }
};
</script>
